export default __webpack_public_path__ + "static/media/bulletinBoard.49bd89a0.png";